module.exports = __webpack_public_path__ + "static/img/y77.2b450b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y77.png
// module id = BDfh
// module chunks = 1